import { Component, OnInit } from '@angular/core';
import { IndependenceModel } from 'src/app/analytic-report/declaration.model';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-my-employee',
  templateUrl: './my-employee.component.html',
  styleUrls: ['./my-employee.component.css'],
})
export class MyEmployeeComponent implements OnInit {
  employeeIndependence: IndependenceModel;
  constructor(private masterDataService: MasterDataService) {}

  ngOnInit(): void {
    this.masterDataService
      .getEmployeeIndependence(localStorage.getItem('id'), 1)
      .subscribe((res) => {
        this.employeeIndependence = res;
        console.log("employeeIndependence",this.employeeIndependence)
      });
  }
}
